import Vue from "vue";
const vm = Vue.prototype;

export const state = () => ({
  schoolTypes: [],
  schoolType: {},
});

export const mutations = {
  SET_SCHOOL_TYPES(state, payload) {
    state.schoolTypes = vm.$toArray(payload);
  },

  SET_SCHOOL_TYPE_BY_ID(state, payload) {
    state.schoolType = payload || {};
  },
};

export const actions = {
  async INIT_SCHOOL_TYPES({ commit }, options) {
    const { itemsPerPage, search = "", sortBy = [], sortDesc = [] } = options;

    const page = Number(options.page - 1) || 0;
    const sortField = sortBy.length ? sortBy[0] : "";
    const sortOrder = sortDesc.length && sortDesc[0] ? "desc" : "asc";

    const senc = search ? encodeURI(search) : null;

    const query = `?page=${page}&size=${itemsPerPage}&name=${senc}&sortField=${sortField}&sortOrder=${sortOrder}`;
    let totalItemsCount = 0;

    const data = await vm.$axios.$get(`admin/school-type${query}`);
    if (data) {
      commit("SET_SCHOOL_TYPES", data.content);

      totalItemsCount = data.totalElements;
    }

    return totalItemsCount;
  },

  async SCHOOL_TYPE_BY_ID({ commit }, { id }) {
    let status = false;

    try {
      const data = await vm.$axios.$get(`admin/school-type/${id}`);
      if (Array.isArray(data)) {
        commit("SET_SCHOOL_TYPE_BY_ID", data);

        status = true;
      }
    } catch (error) {
      //
    }

    return status;
  },

  async ADD_SCHOOL_TYPE(ctx, schoolType) {
    let status = false;
    const url = "admin/school-type";
    const method = schoolType.id ? "$post" : "$put";

    status = await vm.$axios[method](url, schoolType);

    return status;
  },

  async SCHOOL_TYPE_STATUS(ctx, { id, active }) {
    let status = false;

    const url = `admin/school-type/${id}/`;
    const method = !active ? "deactivation" : "activation";

    status = await vm.$axios.$post(url + method);

    return status;
  },
};

export const getters = {
  GET_SCHOOL_TYPES: (state) => state.schoolTypes,
  GET_SCHOOL_TYPE_BY_ID: (state) => state.schoolType,
};
